module.exports = __webpack_public_path__ + "img/logo.277d749a.png";